








































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

import eventBus from '@/utils/eventBus';

import SideModalHeader from '@/components/SideModalHeader/SideModalHeader.vue';
import ScreenLocker from '@/components/ScreenLocker.vue';
import SendCoinsModal from '@/components/SendCoinsModal/SendCoinsModal.vue';
import SendOfferModal from '@/components/SendOfferModal/SendOfferModal.vue';
import Terms from '@/components/Terms/Terms.vue';
import PrivacyPolicy from '@/components/PrivacyPolicy/PrivacyPolicy.vue';
import MobileOfferDetailsPreview from '@/components/MobileOfferDetailsPreview/MobileOfferDetailsPreview.vue';
import NewCampaignModal from '@/views/Admin/CampaignsList/NewCampaignModal.vue';
import FormAddMID from '@/views/Admin/BusinessesList/FormAddMID.vue';
import CustomerDetails from '@/views/CustomersList/CustomerDetails.vue';
import AdminCustomerDetails from '@/views/Admin/CustomersList/CustomerDetails.vue';
import AdminKeywordDetails from '@/views/Admin/KeywordsList/KeywordDetails.vue';
import AdminBusinessDetails from '@/views/Admin/BusinessesList/BusinessDetail.vue';
import AdminTwismWalletDetails from '@/views/Admin/TwismWallet/TwismWalletDetail.vue';
import AdminCoinStoreDetails from '@/views/Admin/CoinStore/CoinStoreDetail.vue';
import AdminTwismWalletSendCoins from '@/views/Admin/TwismWallet/TwismWalletSendCoins.vue';
import AdminCoinStoreSendCoins from '@/views/Admin/CoinStore/CoinStoreSendCoins.vue';
import AdminCoinStoreDealsManager from '@/views/Admin/CoinStore/CoinStoreDealsManager.vue';
import AdminCoinStoreReturnWallet from '@/views/Admin/CoinStore/CoinStoreReturnWallet.vue';
import AdminOnlineTransactions from '@/views/Admin/OnlineTransactions/TransactionsDetail.vue';
import AdminOfferList from '@/views/Admin/Offers/MenuOfferList.vue';
import AdminOfferDetail from '@/views/Admin/Offers/AdminOfferDetail.vue';
import AdminBusinessKeywords from '@/views/Admin/BusinessesList/BusinessKeywords.vue';

import WebhookFakeFidel from '@/views/Admin/OnlineTransactions/WebhookFakeFidel.vue';
import ManuallyReward from '@/views/Admin/OnlineTransactions/ManuallyReward.vue';
import PendingCoinsVerifier from '@/views/Admin/OnlineTransactions/PendingCoinsVerifier.vue';
import ThresholdDetails from '@/views/Transactions/ThresholdDetails.vue';
import LocationDetails from '@/views/Settings/Locations/LocationDetails.vue';
import NewFlagModal from '@/views/Admin/FlagsList/NewFlagModal.vue';
import EditFlagModal from '@/views/Admin/FlagsList/EditFlagModal.vue';

import NewTicketRequest from '@/views/Admin/TicketRequest/NewTicketRequest.vue';
import DetailsTicketRequest from '@/views/Admin/TicketRequest/DetailsTicketRequest.vue';

// NEW SUB MODALS
import AdminCustomerModal from '@/componentsV2/templates/AdminCustomerModal/AdminCustomerModal.vue';

@Component({
  components: {
    NewTicketRequest,
    DetailsTicketRequest,
    EditFlagModal,
    NewFlagModal,
    ScreenLocker,
    SendOfferModal,
    MobileOfferDetailsPreview,
    SendCoinsModal,
    CustomerDetails,
    AdminCustomerDetails,
    AdminKeywordDetails,
    AdminBusinessDetails,
    AdminBusinessKeywords,
    AdminTwismWalletDetails,
    AdminCoinStoreDetails,
    AdminOnlineTransactions,
    WebhookFakeFidel,
    ManuallyReward,
    PendingCoinsVerifier,
    SideModalHeader,
    PrivacyPolicy,
    Terms,
    NewCampaignModal,
    ThresholdDetails,
    FormAddMID,
    LocationDetails,
    AdminCustomerModal,
    AdminTwismWalletSendCoins,
    AdminCoinStoreSendCoins,
    AdminCoinStoreDealsManager,
    AdminCoinStoreReturnWallet,
    AdminOfferList,
    AdminOfferDetail
  }
})
export default class SideModal extends Vue {
  @Prop() component!: string;
  @Prop() typeContent!: string;
  @Prop() subSideModalState!: boolean;
  @Prop() subSideModalContent!: string;
  @Prop() data!: any;
  @Prop() noPaddingBottom!: any;
  @Prop({ default: 'fit-content' }) width?: any;
  @Prop() onClose?: () => any;
  @Prop() secondaryStyle!: boolean;
  @Prop() disabledBackdropClick!: boolean;
  @Prop() autoWidth!: boolean;
  @Prop({ default: '#F7F7F7' }) bgColor?: string;
  @Prop({ default: '629px' }) minWidth?: string;
  @Prop({ default: 'none' }) activePointerEvents?: string;

  right: string = '-100%';
  zIndex: number = -1;
  stateSubSideModal: boolean = false;
  modalVisible: boolean = false;
  timeAnimation: any = {};
  scroll: number = 0;

  dataChanged = false;

  get isMobileDevice() {
    return this.$mobileCheck();
  }

  get subModals() {
    return this.$store.getters['modal/getSubModals'];
  }

  get scopedStyles() {
    return {
      '--scoped-bg-color': this.bgColor,
      '--scoped-min-width': this.minWidth
    };
  }

  handleCloseSubModal() {
    eventBus.$emit('hideSubModal');
    this.stateSubSideModal = false;
  }

  @Watch('modalVisible')
  stateChange(newValue: boolean): void {
    if (newValue) {
      const { body } = document;
      body.style.position = 'fixed';
      body.style.top = `-${this.scroll}px`;
      body.style.right = '0px';
      body.style.left = '0px';
      body.style.overflow = 'hidden';
    } else {
      const { body } = document;
      const { top } = body.style;
      const yValue = -parseInt(top || '0', 10);
      body.style.position = '';
      body.style.top = '';
      body.style.right = '';
      body.style.left = '';
      body.style.overflow = '';
      window.scrollTo(0, yValue);
    }

    if (!newValue) {
      window.removeEventListener('keyup', this.closeModal);
      this.zIndex = -1;
      this.right = `-100%`;
    }
  }

  @Watch('subSideModalState')
  subStateChange(newValue: boolean): void {
    if (newValue) {
      this.timeAnimation = setTimeout(() => {
        this.zIndex = 55;
      }, 425);
      this.getPositionSubModal();
    } else {
      this.timeAnimation && clearTimeout(this.timeAnimation);
      this.zIndex = -1;
      this.right = `-100%`;
    }
  }

  @Watch('data', { deep: true })
  showDialogConfirm() {
    if (this.dataChanged) return;

    this.dataChanged = true;
  }

  async handleClose() {
    if (this.dataChanged && this.data.dialogConfirm) {
      const response = await this.$showConfirmDialog();

      if (response !== 'confirm') return;
    }

    this.closeModal({});
  }

  closeModal(event: any) {
    this.$store.dispatch('modal/CLEAR_ALL_SUB_MODALS');

    if (event.type === 'keyup' && (!event.keyCode || event.keyCode !== 27)) {
      return;
    }

    let timeout: number = 0;
    if (this.stateSubSideModal) {
      this.stateSubSideModal = false;
      timeout = 165; //wait for preview close animation
    }

    if (this.onClose) this.onClose();

    setTimeout(() => {
      this.modalVisible = false;
      setTimeout(() => {
        eventBus.$emit('setSideModalVisible', {
          isOpen: false,
          component: this.component
        });
      }, 400); // wait for sidemodal close animation
    }, timeout);
  }

  mounted() {
    setTimeout(() => {
      this.modalVisible = true;
    }, 1);
  }

  created() {
    this.scroll = window.scrollY;
    window.addEventListener('keyup', this.closeModal);
    eventBus.$on('openModal', () => {
      window.removeEventListener('keyup', this.closeModal);
    });

    eventBus.$on('closedModal', () => {
      window.addEventListener('keyup', this.closeModal);
    });
  }

  getPositionSubModal() {
    const sideModalSize: any = document.querySelector('.side-modal__content');
    this.right = `${sideModalSize.offsetWidth - 1}px`;
  }

  get getStyle() {
    return {
      right: this.isMobileDevice ? 0 : this.right,
      zIndex: this.zIndex
    };
  }
}
